import { BasePageType } from "../base";
import SearchPage from "./SearchPage";

// Sample search categories
const defaultCategories = [
	{
		id: "books",
		name: "Books",
		icon: "book-outline",
		count: 1250,
	},
	{
		id: "discussions",
		name: "Discussions",
		icon: "chatbubbles-outline",
		count: 324,
	},
	{
		id: "events",
		name: "Events",
		icon: "calendar-outline",
		count: 45,
	},
	{
		id: "members",
		name: "Members",
		icon: "people-outline",
		count: 892,
	},
];

// Sample recent searches
const defaultRecentSearches = [
	{
		id: 1,
		query: "The Midnight Library",
		type: "book",
		timestamp: new Date().toISOString(),
	},
	{
		id: 2,
		query: "Science Fiction",
		type: "category",
		timestamp: new Date().toISOString(),
	},
	{
		id: 3,
		query: "Book Club Events",
		type: "events",
		timestamp: new Date().toISOString(),
	},
];

// Sample trending searches
const defaultTrendingSearches = [
	{
		id: 1,
		query: "Project Hail Mary",
		type: "book",
		count: 1205,
	},
	{
		id: 2,
		query: "Mystery Books",
		type: "category",
		count: 892,
	},
	{
		id: 3,
		query: "Summer Reading Challenge",
		type: "event",
		count: 567,
	},
];

export const SearchPageType = {
	...BasePageType,
	component: SearchPage,
	icon: "search-outline",
	title: "Search",
	getDefaultContent: () => ({
		categories: defaultCategories,
		recentSearches: defaultRecentSearches,
		trendingSearches: defaultTrendingSearches,
		searchResults: [],
		activeCategory: "all",
		query: "",
	}),
};

export default SearchPageType;
